import { Modal, Accordion } from "react-bootstrap";
import "./SmartDocsBestPractices.css";

const SmartDocsBestPractices = ({ setShowBestPractices, showBestPractices }: any) => {
    return (
        <Modal
            show={showBestPractices}
            onHide={() => setShowBestPractices(false)}
            centered
            dialogClassName="modal-dialog modal-dialog-centered set-width"
        >
            <Modal.Header closeButton>
                <Modal.Title>SmartDocs Best Practices</Modal.Title>
            </Modal.Header>

            <Modal.Body className="background-color">

                <div className="best-practice-banner">
                    <div className="banner-icon">⚠️</div>
                    <div>
                        <div className="banner-title">SmartDocs Best Practices</div>
                        <div className="banner-text">
                            Follow these tips to ensure your documents are generated perfectly every time.
                        </div>
                    </div>
                </div>

                <Accordion className="smartdocs-accordion">

                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <span className="accordion-icon">📄</span> File Requirements
                        </Accordion.Header>

                        <Accordion.Body>
                            <ul>
                                <li>
                                    <b>Format:</b> Only PDF files can be uploaded.
                                </li>
                                <li>
                                    <b>Naming Convention:</b> Ensure file name do not contain special characters
                                    (e.g., #, $, %, @).
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <span className="accordion-icon">🏷️</span> Data Tag Optimization
                        </Accordion.Header>

                        <Accordion.Body>

                            <p>
                                <b>Allow Adequate Space:</b> Ensure sufficient space in the document for all
                                possible values of a data tag.
                            </p>

                            <p>
                                Example: <b>{`{Customer_Name}`}</b> or <b>{`{ServiceAddress}`}</b> may contain long
                                values, so leave adequate space.
                            </p>

                            <p>
                                <b>Space Should Match Data Values - Not Tag Names:</b> Document only needs space
                                for the value inserted, not the full tag name.
                            </p>

                            <p>
                                Example: If the Early Termination Fee value is <b>$200</b>, space only needs to
                                accommodate <b>$200</b>, not the full tag <b>{`{EarlyTerminationFee}`}</b>.
                            </p>

                            <p>
                                <b>Anchor Point:</b> Data tags are placed based on the center-left corner of your cursor.
                            </p>

                            <p>
                                <b>Global Styling:</b> Font size and family are managed in <b>Document Setup</b>.
                                These settings apply to all documents globally.
                            </p>

                            <div className="important-box">
                                ⚠ <b>Important:</b> Always size document fields based on the maximum possible value,
                                not the tag label.
                            </div>

                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                        <Accordion.Header>
                            <span className="accordion-icon">🔍</span> Handling Missing Data
                        </Accordion.Header>

                        <Accordion.Body>
                            <p>
                                <b>Blank Values:</b> If a data tag exists in SmartDocs but has no corresponding
                                value in the Product settings, it will appear blank on the final document delivered
                                to the customer.
                            </p>

                            <p>
                                Example: If the Early Termination Fee field is empty in the product configuration,
                                the document will show no value.
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>
                            <span className="accordion-icon">⚙️</span> Workflow & Delivery
                        </Accordion.Header>

                        <Accordion.Body>
                            <p>
                                <b>Automated Dispatch:</b> Once the Quality Control (QC) process is complete,
                                customers automatically receive all relevant documents.
                            </p>

                            <p>
                                <b>eContract Sequencing:</b> If delivery is set to <b>"After Enrollment"</b>,
                                the customer must sign all documents before they can proceed to TPVs
                                (Text, IVR or Live Agent TPV).
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>

                </Accordion>

            </Modal.Body>
        </Modal>
    );
};

export default SmartDocsBestPractices;